import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const displayTextMenuSlice = createSlice({
	name: 'displayTextMenu',
	initialState,
	reducers: {
		setDisplayTextMenu: (state) => {
			return !state;
		},
		expandDisplayTextMenu: () => {
			return true;
		},
		collapseDisplayTextMenu: () => {
			return false;
		}
	}
});

export const { setDisplayTextMenu, expandDisplayTextMenu, collapseDisplayTextMenu } = displayTextMenuSlice.actions;

export default displayTextMenuSlice.reducer;
